import { Reducer, combineReducers } from 'redux'
import * as WpsTypes from 'DVWebNodeWpsRuntime'
import { createMergeReducer } from '../utils/reducer'
import { DetailPageActions, DetailPageActionTypes } from '../actions'

export type TitleIdToRefund = {
  [titleId: string]: WpsTypes.atv.wps.RefundFragmentModel | undefined
}

export type Refunding = {
  titleId: string
} | null

export type IRefundState = {
  fragments: TitleIdToRefund
  refunding: Refunding
}

const fragmentsInitialState = {} as TitleIdToRefund

const fragmentsReducer: Reducer<TitleIdToRefund, DetailPageActions> = (
  state = fragmentsInitialState,
  action
) => {
  switch (action.type) {
    case DetailPageActionTypes.RefreshAtfActionBox:
    case DetailPageActionTypes.RefreshBtfActionBoxes:
    case DetailPageActionTypes.RefreshEpisode:
      return (
        (action.output &&
          action.output.refund && {
            ...state,
            ...action.output.refund.fragments,
          }) ||
        state
      )
    default:
      return state
  }
}

const refundingInitialState = null as Refunding

const refundingReducer: Reducer<Refunding, DetailPageActions> = (
  state = refundingInitialState,
  action
) => {
  switch (action.type) {
    case DetailPageActionTypes.TriggerRefund:
      // make sure that current refund is complete before starting a new one
      return state || { ...action.payload }
    case DetailPageActionTypes.RefundCancelled:
    case DetailPageActionTypes.RefundFailed:
    case DetailPageActionTypes.RefreshAtfActionBox:
    case DetailPageActionTypes.RefreshBtfActionBoxes:
    case DetailPageActionTypes.RefreshEpisode:
      return null
    default:
      return state
  }
}

export const reducer = combineReducers<IRefundState, DetailPageActions>({
  fragments: createMergeReducer(
    t => t.refund && t.refund.fragments,
    fragmentsInitialState,
    fragmentsReducer
  ) as Reducer<TitleIdToRefund, DetailPageActions>,
  refunding: refundingReducer,
})
